module.exports = __webpack_public_path__ + "static/media/item_40_4.09ab3250.png";